import React, { useState } from "react";
import DataFetchHook from "../../helper/DataFetchHook";
import DraggableModal from "../../helper/DraggableModal";
import { Table, Button, Modal, Typography, Tooltip } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import moment from "moment";
import axios from "axios";
import Swal from "sweetalert2";
import Cookies from "js-cookie";
import { API, DISABLE_MATCH_REFUND } from "../../config/config";

const { confirm } = Modal;
const { Paragraph } = Typography;

const DATA_URL = "/alerttransactionmatches";
const DATA_URL_MARK = "/marktransactionalert";

const AlertsForReviewRDR = (props) => {
    const { t, alertid, isresolved,getAlert } = props;
    const [{ data }, doFetch] = DataFetchHook(`${DATA_URL}?alertid=${alertid}`);
    const [modal, setModal] = useState({ title: "", content: "" });
    const [isModalVisible, setIsModalVisible] = useState(false);

    const showModal = (params) => {
        setModal(params);
        setIsModalVisible(true);
    };

    const handleOk = () => {
        setIsModalVisible(false);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    const IsJsonString = (str) => {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    };

    function findArrayElementByMatchid(array, matchid) {
        return array.find((element) => {
          return element.matchid === matchid;
        })
      }
    const processMatch = (matchid) => {
        const { alertid, orderid } = data.datalist ? findArrayElementByMatchid( data.datalist,matchid) : null;

        confirm({
            title: t("contents.possiblerdrtransactionmatches.confirm.q_1"),
            content: (
                <div>
                    <p>
                        {t("contents.possiblerdrtransactionmatches.confirm.notice_1")}
                        <br />
                        {t("contents.possiblerdrtransactionmatches.confirm.notice_11")} of order <strong>{orderid}</strong>{" "}
                        {t("contents.possiblerdrtransactionmatches.confirm.notice_12")} .
                    </p>
                    <p>
                        {t("contents.possiblerdrtransactionmatches.confirm.notice_21")} <strong>{alertid}</strong>{" "}
                        {t("contents.possiblerdrtransactionmatches.confirm.notice_22")} <br />
                    </p>
                </div>
            ),
            icon: <ExclamationCircleOutlined />,
            okText: t("header.menu.logout.yes"),
            okType: "danger",
            cancelText: t("header.menu.logout.no"),
            width: "650px",
            onOk() {
                return new Promise((resolve, reject) => {
                    axios
                        .post(
                            API + DATA_URL_MARK,
                            { matchid: matchid },
                            { headers: { "content-type": "application/json", Authorization: "Bearer " + Cookies.get("access_token") } }
                        )
                        .then(({ data }) => {
                            if (data.status === "OK") {
                                resolve();
                                Swal.fire({
                                    icon: "success",
                                    title: data.msg ? data.msg : "Marked alert successful",
                                    showConfirmButton: false,
                                    timer: 2000,
                                    onClose: () => {
                                        getAlert(alertid);
                                    },
                                });
                            } else {
                                reject();
                                Swal.fire({
                                    icon: "error",
                                    title: "Could not refund.",
                                    text: data.msg ? data.msg : data,
                                    showConfirmButton: true,
                                });
                            }
                        })
                        .catch((error) => {
                            reject();
                            Swal.fire({
                                icon: "error",
                                title: error,
                                showConfirmButton: false,
                                timer: 2000,
                                onClose: () => {
                                    doFetch(DATA_URL + `?alertid=${alertid}&${moment().unix()}`);
                                },
                            });
                        }); 
              
                });
            },
            onCancel() {
                return false;
            },
        });
    };

    const columns = [
        {
            dataIndex: "datecreated",
            key: "datecreated",
            width: 80,
            title: t("tables.fields.retrieval_date"),
            render: (datecreated) => moment(datecreated).format("DD-MMM"),
        },
        {
            dataIndex: "cardnumber",
            key: "cardnumber",
            title: t("tables.fields.cardnumber"),
            width: 140,
        },
        {
            dataIndex: "transaction_amount",
            key: "transaction_amount",
            title: t("tables.fields.amount"),
            align: "left",
            width: 80,
            ellipsis: true,
        },
        {
            dataIndex: "gwname",
            key: "gwname",
            title: t("tables.fields.gwname"),
            width: 130,
        },
        {
            dataIndex: "gw_descriptor",
            key: "gw_descriptor",
            title: t("tables.fields.gw_descriptor"),
            width: 130,
        },
        {
            dataIndex: "orderid",
            key: "orderid",
            title: t("tables.fields.orderid"),
            width: 100,
            render: (orderid, record) => (
                <Tooltip title={orderid}>
                    <Button
                        type="link"
                        size="small"
                        style={{whiteSpace: "normal",height:'auto',marginBottom:'10px',maxWidth:"100%"}}
                        onClick={() => showModal({ title: t("contents.possibletransactionmatches.transaction_info"), content: record.transaction_info })}
                    >
                        <span style={{overflow: "hidden",textOverflow: "ellipsis",whiteSpace: "nowrap",display: "block"}}>{orderid}</span>
                    </Button>
                </Tooltip>
            ),
        },
        {
            dataIndex: "gw_transaction_date",
            key: "gw_transaction_date",
            title: t("tables.fields.gw_transaction_date"),
            align: "center",
            width: 130,
            render: (alertdate) => moment(alertdate).format("lll"),
        },
        {
            dataIndex: "gw_transactionid",
            key: "gw_transactionid",
            title: t("tables.fields.gw_transactionid"),
            align: "center",
            width: 130,
        },
        {
            dataIndex: "matchscore",
            key: "matchscore",
            title: t("tables.fields.matchscore"),
            align: "center",
            width: 90,
        },
        {
            dataIndex: "refundstatus",
            key: "refundstatus",
            title: t("tables.fields.refundstatus"),
            fixed: "right",
            width: 120,
            render: (refundstatus, record) => t(`specialset.${refundstatus}`),
        },
        {
            dataIndex: "alertstatus",
            key: "alertstatus",
            title: t("tables.fields.alertstatus"),
            fixed: "right",
            width: 120,
            render: (alertstatus, record) => t(`specialset.${alertstatus}`),
        },
        {
            dataIndex: "action",
            key: "action",
            title: t("tables.fields.action"),
            align: "left",
            fixed: "right",
            width: 90,
            render: (text, record) => ((record.action && record.action !== '') ?  "":getActionButton(record.matchid)),
        },
    ];

    const getActionButton = (matchid) => (
        <Button size="small" onClick={() => processMatch(matchid)}>
            {t("tables.actions.resolve")}
        </Button>
    );

    const getDataSource = (datalist) =>
    datalist && Array.isArray(datalist)
    ? datalist.map((data) => ({ ...data, refundstatus: data.refundstatus ? data.refundstatus.replaceAll(" ", "_").toLowerCase() : "", alertstatus: data.alertstatus ? data.alertstatus.replaceAll(" ", "_").toLowerCase() : "" }))
    : [];

    const getModalComponent = () => (
        <DraggableModal
            name={modal.title}
            visible={isModalVisible}
            onOk={handleOk}
            onCancel={handleCancel}
            width={800}
            footer={[
                <Button key="submit" type="primary" onClick={handleOk}>
                    {t("tables.actions.ok")}
                </Button>,
            ]}
            context={
                <Typography>
                    <Paragraph className="well">
                        {IsJsonString(modal.content) ? JSON.stringify(JSON.parse(modal.content), null, "\t") : modal.content}
                    </Paragraph>
                </Typography>
            }
        />
    );

    const getColumns = () => {
        if (!DISABLE_MATCH_REFUND && !isresolved) {
            return columns;
        } else {
            return columns.filter((column) => column.dataIndex !== "action");
        }
    };

    const isTransactionMatched = () => (data ? (data.datalist ? !!data.datalist.filter((row) => row.refundedcode === 1) : false) : false);


    return (
        <>
            <h2 style={{ marginBottom: "1.5rem" }}>
                {isTransactionMatched() ? t("contents.possiblerdrtransactionmatches.title_matched") : t("contents.possiblerdrtransactionmatches.title")}
            </h2>
            {getModalComponent()}
            <Table
                size="middle"
                columns={getColumns()}
                rowKey="matchid"
                scroll={{ x: 1200 }}
                dataSource={getDataSource(data.datalist)}
                pagination={false}
            />
        </>
    );
};

export default AlertsForReviewRDR;
